<template>
  <div class="basic_wrap">
    <!-- ================= 顶部导航 ================= -->
    <div class="custom_header">
      <div class="back_btn" @click="$router.back()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </div>
      <div class="header_title">{{ $t('user.vip') }}</div>
    </div>

    <div class="main_content">
      <!-- ================= 1. 顶部用户横幅 ================= -->
      <div class="banner_card">
        <div class="user_row">
          <div class="avatar_box">
            <img :src="user.user_icon" alt="avatar">
          </div>
          <div class="user_info">
            <div class="user_name">{{ user.username }}</div>
            <div class="vip_tag">
              <span class="crown">👑</span> {{ vip.name }}
            </div>
          </div>
          <div class="vip_badge">
            <img :src="vip.logo" alt="badge">
          </div>
        </div>
      </div>

      <!-- ================= 2. 我的资产卡片 ================= -->
      <div class="card_box asset_card">
        <div class="card_title">{{ $t('vip.myMoney') }}</div>
        <div class="asset_grid">
          <div class="asset_item">
            <div class="item_val">{{ common.currency_symbol_basic() }}{{ common.precision_basic(user.money_r) }}</div>
            <div class="item_label">{{ $t('utils.lunlog42') }}</div>
          </div>
          <div class="asset_item">
            <div class="item_val">{{ common.currency_symbol_basic() }}{{ common.precision_basic(user.balance) }}</div>
            <div class="item_label">{{ $t('utils.lunlog43') }}</div>
          </div>
        </div>
      </div>

      <!-- ================= 3. 进度条卡片 ================= -->
      <div class="card_box progress_card">
        <div class="progress_labels">
          <span class="label_val">{{ vip.this_value }}</span>
          <span class="label_val">{{ vip.next_value }}</span>
        </div>
        <div class="progress_bar_wrap">
          <!-- 遮罩/底层灰条 -->
          <div class="track"></div>
          <!-- 进度条 -->
          <div class="fill" :style="{ width: percentage + '%' }"></div>
        </div>
        <div class="progress_under" v-if="percentage < 100">
          <span class="current_tip">{{ user.user_value }}</span>
        </div>
      </div>

      <!-- ================= 4. 我的权益卡片 ================= -->
      <div class="card_box rights_card">
        <div class="card_title">{{ $t('vip.myRights') }}</div>
        <div class="rights_list">
          <div class="right_item">
            <div class="num_badge">1</div>
            <div class="desc_text">{{ $t('vip.rights') }}1: {{ $t('vip.investNum') }}<span style="color:red">{{ vip.invest_num }}{{ $t('utils.times'+times) }}</span></div>
          </div>
          <div class="right_item">
            <div class="num_badge">2</div>
            <div class="desc_text">{{ $t('vip.rights') }}2: {{ $t('utils.lunlog16') }}:<span style="color:red"> {{ vip.rewards_direct }}%</span></div>
          </div>
          <div class="right_item">
            <div class="num_badge">3</div>
            <div class="desc_text">{{ $t('vip.rights') }}3: {{ $t('utils.lunlog17') }}:<span style="color:red"> {{ vip.rewards_undirect }}%</span></div>
          </div>
          <div class="right_item">
            <div class="num_badge">4</div>
            <div class="desc_text">{{ $t('vip.rights') }}4: {{ $t('utils.lunlog18') }}:<span style="color:red"> {{ vip.rewards_there }}%</span></div>
          </div>
        </div>
      </div>

      <!-- ================= 5. 等级阶梯说明表格 ================= -->
      <div class="card_box table_card" v-html="guize" />
      
      <div style="height: 40px;"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue';
import Fetch from '../../utils/fetch';
import Clipboard from "v-clipboard";
import { Progress } from 'vant';

Vue.use(Progress).use(Clipboard);

export default {
  name: "Vip",
  components: { bsHeader },
  data() {
    return {
      data: [],
      guize: '',
      vip: {
        invest_num: '',
        rewards_direct: '',
        rewards_undirect: '',
        name: '',
        logo: '',
        this_value: 0,
        next_value: 0
      },
      user: {
        balance: 0,
        income: 0,
        user_value: 0,
        username: '',
        invite_code: '',
        user_icon: ''
      },
      percentage: 0,
      times: 0
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/getVip').then(r => {
        this.vip = r.data.vip;
        this.user = r.data.user;
        this.times = r.data.vip.invest_num;
        this.guize = r.data.guize;
        if (this.times > 1) this.times = 2;
        
        if (r.data.vip.next_value == r.data.vip.this_value) {
          this.percentage = 100;
        } else {
          this.percentage = (r.data.user.user_value - r.data.vip.this_value) / (r.data.vip.next_value - r.data.vip.this_value) * 100;
        }
        // 防止进度条溢出
        if (this.percentage > 100) this.percentage = 100;
        if (this.percentage < 0) this.percentage = 0;
      })
    },
    copy() {
      this.$toast(this.$t('recharge.copySuccess'));
    },
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  min-height: 100vh;
  padding-bottom: 60px;
  /* 浅蓝网格纹理背景 */
    background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

/* ================= 顶部导航 ================= */
.custom_header {
  display: flex;
  align-items: center;
  padding: 16px 16px 8px;
  
  .back_btn {
    width: 32px; height: 32px;
    background: #ffffff;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; margin-right: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  }
  .header_title {
    font-size: 18px; font-weight: 700; color: #111;
  }
}

.main_content {
  padding: 0 16px 20px;
}

/* ================= 通用白色卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(24, 61, 122, 0.06);
  border: 1px solid rgba(220, 229, 239, 0.5);
}
.card_title {
  font-size: 16px; font-weight: 700; color: #111; margin-bottom: 14px;
}

/* ================= 1. 用户横幅 ================= */
.banner_card {
  padding: 20px 16px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  border-radius: 18px;
  margin-bottom: 16px;
  border: 1px solid rgba(37, 99, 235, 0.3);

  .user_row {
    display: flex; align-items: center;
    .avatar_box {
      width: 50px; height: 50px;
      border-radius: 50%; border: 2px solid rgba(255,255,255,0.2);
      overflow: hidden; flex-shrink: 0;
      img { width: 100%; height: 100%; object-fit: cover; }
    }
    .user_info {
      flex: 1; margin-left: 14px;
      .user_name { font-size: 18px; font-weight: 700; color: #fff; }
      .vip_tag {
        display: inline-block; margin-top: 4px;
        background: rgba(255,255,255,0.2); padding: 2px 10px;
        border-radius: 12px; font-size: 12px; font-weight: 600; color: #fff;
        .crown { margin-right: 4px; }
      }
    }
    .vip_badge {
      img { height: 30px; object-fit: contain; }
    }
  }
}

/* ================= 2. 资产卡片 ================= */
.asset_card {
  .asset_grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 12px;
    .asset_item {
      background: #f8faff; border-radius: 10px; padding: 16px 0; text-align: center;
      .item_val { font-size: 16px; font-weight: 700; color: #111; margin-bottom: 4px; }
      .item_label { font-size: 12px; color: #64748b; }
    }
  }
}

/* ================= 3. 进度条卡片 ================= */
.progress_card {
  .progress_labels {
    display: flex; justify-content: space-between;
    color: #64748b; font-size: 12px; margin-bottom: 6px;
  }
  .progress_bar_wrap {
    position: relative; height: 8px; border-radius: 4px; overflow: hidden;
    background: #e2e8f0; /* 灰色底 */
    .fill {
      position: absolute; top: 0; left: 0; height: 100%;
      background: #2563eb; border-radius: 4px;
      transition: width 0.4s ease;
    }
  }
  .progress_under {
    margin-top: 8px; text-align: center; font-size: 12px; color: #64748b;
  }
}

/* ================= 4. 权益列表 ================= */
.rights_card {
  .rights_list {
    display: flex; flex-direction: column; gap: 12px;
    .right_item {
      display: flex; align-items: center; gap: 12px;
      background: #f8faff; padding: 12px 16px; border-radius: 12px;
      .num_badge {
        width: 28px; height: 28px; border-radius: 50%;
        background: #2563eb; color: #fff;
        display: flex; align-items: center; justify-content: center;
        font-size: 13px; font-weight: 700; flex-shrink: 0;
      }
      .desc_text {
        font-size: 14px; font-weight: 500; color: #111;
      }
    }
  }
}

/* ================= 5. 等级阶梯说明表格 ================= */
.table_card {
  /* 深度选择器，因为 v-html 注入的样式需要在这里生效 */
  :deep(table) {
    width: 100%; border-collapse: separate; border-spacing: 0 6px;
    border: none;
  }
  :deep(td), :deep(th) {
    padding: 14px 10px; border: none; text-align: center;
    font-size: 12px; color: #475569;
  }
  :deep(thead th) {
    background: #2563eb; color: #fff; font-weight: 600;
    border-radius: 8px 8px 0 0;
  }
  :deep(tbody td) {
    background: #f8faff; border-radius: 8px;
    vertical-align: middle;
  }
  :deep(tbody tr:last-child td:first-child) { border-radius: 8px 0 0 8px; }
  :deep(tbody tr:last-child td:last-child) { border-radius: 0 8px 8px 0; }
}
</style>